<template>
  <div class="sd-page">
    <header class="sd-page-head">
      <div>
        <p class="sd-eyebrow">Multimedia</p>
        <h1 class="sd-title">Galería</h1>
        <p class="sd-subtitle">Fotos y vídeos de las celebraciones y actividades de la parroquia.</p>
      </div>

      <label v-if="lista.length" class="sd-search">
        <span class="material-symbols-outlined">search</span>
        <input v-model.trim="search" type="search" placeholder="Buscar álbum…" aria-label="Buscar álbum" />
        <button v-if="search" type="button" aria-label="Limpiar búsqueda" @click="search = ''">
          <span class="material-symbols-outlined">close</span>
        </button>
      </label>
    </header>

    <div v-if="loading" class="sd-grid">
      <div v-for="n in 8" :key="n" class="sd-skeleton galeria-skeleton"></div>
    </div>

    <p v-else-if="error" class="sd-empty">
      <span class="material-symbols-outlined">cloud_off</span>
      No se pudo cargar la galería.
      <button type="button" class="sd-btn sd-btn--ghost" @click="cargar">Reintentar</button>
    </p>

    <p v-else-if="!filtrada.length" class="sd-empty">
      <span class="material-symbols-outlined">photo_library</span>
      {{ search ? `No hay álbumes que coincidan con «${search}».` : "Todavía no hay álbumes publicados." }}
    </p>

    <div v-else class="sd-grid">
      <cardView
        v-for="item in filtrada"
        :key="item.id"
        :imageSrc="item.imagenGaleria"
        :imagetitle="item.titulo"
        :idGallery="item.id"
        @getIdGalery="getId"
      />
    </div>
  </div>
</template>

<script>
import cardView from "@/components/galeria/CardView.vue";
import axios from "@/directives/axios.js";
import { track, trackBusqueda } from "@/directives/analitica.js";

// La galería 1 es la del carrusel de la portada: no se muestra como álbum
const GALERIA_PORTADA = 1;

function normalizar(texto) {
  return (texto || "")
    .toString()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "");
}

export default {
  name: "vistaGaleria",
  components: {
    cardView,
  },
  metaInfo() {
    return {
      title: `${this.$root.constantes.nombre_sitio} - Multimedia`,
      meta: [
        {
          name: "description",
          content: `Imágenes y vídeos de actividades de la ${this.$root.constantes.nombre_sitio}`,
        },
      ],
      link: [
        {
          rel: "canonical",
          href: `${this.$root.constantes.sitio_web}${this.$route.fullPath}`,
        },
      ],
    };
  },
  data() {
    return {
      lista: [],
      loading: true,
      error: false,
      search: "",
    };
  },
  computed: {
    filtrada() {
      const q = normalizar(this.search);
      return q ? this.lista.filter((g) => normalizar(g.titulo).includes(q)) : this.lista;
    },
  },
  watch: {
    search(texto) {
      trackBusqueda("galeria", texto);
    },
  },
  mounted() {
    this.cargar();
  },
  methods: {
    async cargar() {
      this.loading = true;
      this.error = false;
      try {
        const { data } = await axios.get("/imagenes/todasGalerias");
        // De más nueva a más antigua (el id crece con cada galería creada)
        this.lista = (data.todasGalerias || [])
          .filter((g) => g.id != GALERIA_PORTADA)
          .sort((a, b) => Number(b.id) - Number(a.id));
      } catch (e) {
        this.error = true;
      } finally {
        this.loading = false;
      }
    },
    getId(value) {
      track("abrir_album", { item_id: String(value.id), item_name: value.title, origen: "galeria" });
      this.$router.push({
        name: "carrete",
        query: { id: value.id, title: (value.title || "").replace(/ /g, "_") },
      });
    },
  },
};
</script>

<style scoped>
.galeria-skeleton {
  aspect-ratio: 4 / 3;
}
</style>
